import { render } from "./CommonHead.vue?vue&type=template&id=7200b995&scoped=true&ts=true"
import script from "./CommonHead.vue?vue&type=script&lang=ts"
export * from "./CommonHead.vue?vue&type=script&lang=ts"

import "./CommonHead.vue?vue&type=style&index=0&id=7200b995&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7200b995"]])

export default __exports__